
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { KanbanState } from '../kanban.model';
import { Card, KanbanTimeTrackingStopRequest, TimeTracker } from '../../backend/backendapi';
import { formatDateTimeForInput, formatDuration, parseDateTimeFromInput } from '../../../util';
import { handleError } from '../../../api';

Vue.use(Toasted, { duration: 2000 });

@Component
export default class TrackerOverrunModal extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  card: Card | null = null;
  tracker: TimeTracker | null = null;
  comment: string | null = null;
  stopTimeForInput: string = formatDateTimeForInput(new Date());

  get canConfirm(): boolean {
    return this.tracker
        && this.tracker.startTime.getTime() < this.stopTime.getTime();
  }

  get formattedDuration(): string {
    if (!this.tracker) {
      return '';
    }
    return formatDuration(Math.max(this.stopTime.getTime() - this.tracker.startTime.getTime(), 0) / 1000);
  }

  get stopTime(): Date {
    return parseDateTimeFromInput(this.stopTimeForInput);
  }

  public open(card: Card, tracker: TimeTracker, comment: string): void {
    this.card = card;
    this.tracker = tracker;
    this.comment = comment;
    this.stopTimeForInput = formatDateTimeForInput(new Date());
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async save(): Promise<void> {
    if (!this.tracker || !this.card) {
      return;
    }

    const card = this.card;
    const tracker = this.tracker;

    try {
      const duration = await this.state.timeTrackingApi.stop(new KanbanTimeTrackingStopRequest({
        id: this.tracker.id,
        comment: this.$t('kanban.timeTracking.trackerOverrun.commentPrefix') + ': ' + this.comment,
        stopTime: this.stopTime,
      }));
      card.durations ??= [];
      card.durations.push(duration);

      const index = this.state.timeTrackers.findIndex(e => e.id === tracker.id);
      if (index > -1) {
        this.state.timeTrackers.splice(index, 1);
      }
      
      this.dismiss();
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    }
  }
}
